import { PaymentProvider } from '@/hooks/invoice/types';
import { validateCheckCharacter } from '@/utils/luhn';
import { z } from 'zod';

export const referenceCodeSchema = z
  .string()
  .length(7, { message: 'page.pay.errors.reference-number-length' })
  .regex(/^[a-df-hj-km-np-zA-DF-HJ-KM-NP-Z]+$/, {
    message: 'page.pay.errors.reference-number-invalid-characters'
  })
  .refine((value) => validateCheckCharacter(value), {
    message: 'page.pay.errors.reference-number-checksum'
  });

export const createPartialPaymentSchema = ({
  minimumPaymentAmount,
  totalAmount,
  serviceProvider
}: {
  minimumPaymentAmount: number;
  totalAmount: number;
  serviceProvider: PaymentProvider | undefined;
}) => {
  return z
    .number()
    .min(minimumPaymentAmount, {
      message:
        serviceProvider?.toLowerCase() === 'inveroak'
          ? 'page.pay.errors.other-amount-card-min-value'
          : 'page.pay.errors.other-amount-min-value'
    })
    .max(totalAmount, { message: 'page.pay.errors.other-amount-max-value' })
    .refine(
      (value) => {
        // Check if the number has at most 2 decimal places
        const decimalPlaces = value.toString().split('.')[1]?.length || 0;
        return decimalPlaces <= 2;
      },
      {
        message: 'page.pay.errors.max-two-decimals'
      }
    )
    .optional();
};
